import { compose } from 'recompose';
import { themr } from '@friendsofreactjs/react-css-themr';

import ModalComponent from './Modal';
import intlEquipped from '../../../hocs/intlEquipped';

const Modal = compose(
    themr('ModalWrapper'),
    intlEquipped
)(ModalComponent);

export default Modal;
